var map = {
	"./AmzGen.jpg": 9857,
	"./BlackBerry.jpeg": 2202,
	"./Bybit-Terminal.png": 7885,
	"./Discord.jpg": 1231,
	"./GCTO.jpeg": 8143,
	"./Icon.png": 3669,
	"./Krates.png": 3538,
	"./Rocky.png": 1410,
	"./StashedLogoGold.jpg": 3885,
	"./Stashio.png": 2748,
	"./Stats-Purple.png": 8059,
	"./Stats-Template.png": 4230,
	"./TDBank.png": 1388,
	"./TMUPrep.png": 7822,
	"./Terminal.png": 186,
	"./TorontoCypress.png": 9756,
	"./TurretShooter.png": 5156,
	"./github.jpg": 5439,
	"./rockybitmoji.png": 7608
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;